import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { 
  History, 
  ChevronDown, 
  ChevronUp, 
  Clock,
  FileText,
  Edit2,
  Send,
  Package,
  Upload,
  Download
} from "lucide-react";

// Action icons mapping
const actionIcons = {
  create: FileText,
  update: Edit2,
  status_change: Send,
  items_update: Package,
  import_windoorcraft: Upload,
  pdf_generated: Download
};

const HistorySection = ({
  isOpen,
  onOpenChange,
  history,
  loadingHistory
}) => {
  return (
    <Collapsible open={isOpen} onOpenChange={onOpenChange}>
      <Card className="border-slate-200">
        <CollapsibleTrigger asChild>
          <CardHeader className="cursor-pointer hover:bg-slate-50 transition-colors py-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-sm flex items-center gap-2">
                <History className="w-4 h-4" />
                Historial de Cambios
                {history.length > 0 && (
                  <span className="bg-slate-200 text-slate-600 text-xs px-2 py-0.5 rounded-full">
                    {history.length}
                  </span>
                )}
              </CardTitle>
              {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </div>
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent className="pt-0">
            {loadingHistory ? (
              <div className="flex items-center justify-center py-4">
                <Clock className="w-5 h-5 animate-spin text-slate-400" />
              </div>
            ) : history.length === 0 ? (
              <p className="text-sm text-slate-500 text-center py-4">
                No hay historial de cambios
              </p>
            ) : (
              <div className="space-y-2 max-h-60 overflow-auto">
                {history.map((entry, index) => {
                  const ActionIcon = actionIcons[entry.action] || FileText;
                  return (
                    <div 
                      key={entry.id || `history-${index}`}
                      className="flex items-start gap-3 p-2 bg-slate-50 rounded-lg"
                    >
                      <div className="mt-0.5">
                        <ActionIcon className="w-4 h-4 text-slate-500" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium">{entry.summary}</p>
                        <p className="text-xs text-slate-500">
                          {entry.user_name} • {new Date(entry.timestamp).toLocaleString('es-PE')}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
};

export default HistorySection;
